var _rect, _path, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiiferBurgerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 707,
    height: 782,
    viewBox: "0 0 707 782",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 572.5,
    width: 707,
    height: 60,
    rx: 30,
    fill: "#EB112E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 149.5C35.1015 149.5 6 178.601 6 214.5V492.5C6 528.398 35.1015 557.5 71 557.5H632C667.898 557.5 697 528.398 697 492.5V214.5C697 178.601 667.898 149.5 632 149.5H71ZM640 207.5H63V513.5H640V207.5Z",
    fill: "#EB112E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 271.5,
    width: 54,
    height: 176,
    rx: 27,
    fill: "#EB112E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 332.501,
    width: 54,
    height: 176,
    rx: 27,
    transform: "rotate(90 291 332.501)",
    fill: "#EB112E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 445.5,
    cy: 359,
    r: 32.5,
    fill: "#EB112E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.5,
    cy: 359,
    r: 32.5,
    fill: "#EB112E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 413,
    r: 32.5,
    fill: "#EB112E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 306,
    r: 32.5,
    fill: "#EB112E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1682 124.056C54.0178 59.9831 123.12 18.836 199.393 12.5727L265.309 7.15985C323.34 2.39449 381.663 2.35186 439.701 7.03237L497.691 11.709C582.299 18.5322 659.261 63.3145 707 133.5V133.5H6L12.1682 124.056Z",
    fill: "#EB112E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M700.832 657.944C658.982 722.017 589.88 763.164 513.607 769.427L447.691 774.84C389.66 779.606 331.337 779.648 273.299 774.968L215.309 770.291C130.701 763.468 53.7388 718.685 6 648.5V648.5L707 648.5L700.832 657.944Z",
    fill: "#EB112E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiiferBurgerLogo);
export default __webpack_public_path__ + "static/media/liifer-burger-logo.401696e1405c8f846cc75cf37a4c588e.svg";
export { ForwardRef as ReactComponent };